/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoiceedit2Inputs */

const en_ticketsinvoiceedit2 = /** @type {(inputs: Ticketsinvoiceedit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change details`)
};

const de_ticketsinvoiceedit2 = /** @type {(inputs: Ticketsinvoiceedit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben ändern`)
};

/**
* | output |
* | --- |
* | "Change details" |
*
* @param {Ticketsinvoiceedit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoiceedit2 = /** @type {((inputs?: Ticketsinvoiceedit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoiceedit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoiceedit2(inputs)
	return de_ticketsinvoiceedit2(inputs)
});
export { ticketsinvoiceedit2 as "ticketsInvoiceEdit" }